import { h, F as Fragment } from './index-3f35faca.js';
import { H as Hidden } from './initialization-utils-0f4cc0aa.js';

/**
 * @deprecated use the lit equivalent
 */
const PagerGuard = (props, children) => {
    if (props.hasError || !props.isAppLoaded || !props.hasItems) {
        return h(Hidden, null);
    }
    return h(Fragment, null, ...children);
};

export { PagerGuard as P };

//# sourceMappingURL=stencil-pager-guard-c56fa035.js.map